import { useQuery } from "@tanstack/react-query";

import { type ChartInterval, getMeasurementHistory } from "@/adapters/api";
import { chartKeys } from "../utils/query-keys.ts";

const STALE_TIME = 60_000;

export interface UseMeasurementHistoryParams {
	constructionId: string | undefined;
	referenceDate: string;
	interval?: ChartInterval;
	enabled?: boolean;
}

export function useMeasurementHistory({
	constructionId,
	referenceDate,
	interval = "monthly",
	enabled = true,
}: UseMeasurementHistoryParams) {
	return useQuery({
		queryKey: chartKeys.measurements(constructionId, referenceDate, interval),
		queryFn: () =>
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			getMeasurementHistory(constructionId!, { interval, referenceDate }),
		enabled: enabled && !!constructionId,
		staleTime: STALE_TIME,
	});
}
